import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import {DragDropModule} from '@angular/cdk/drag-drop';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MatCardModule, MatButtonModule} from '@angular/material';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatDialogModule} from '@angular/material/dialog';
import {MatInputModule} from '@angular/material/input';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatToolbarModule} from '@angular/material/toolbar';


import { AppComponent } from './app.component';
import { DialogRecComponent } from './dialog-rec/dialog-rec.component';

@NgModule({
  declarations: [
    AppComponent,
    DialogRecComponent
  ],
  imports: [
    BrowserModule, DragDropModule, BrowserAnimationsModule,
    MatCardModule, MatButtonModule, MatExpansionModule,
    MatDialogModule, MatInputModule, FormsModule, MatCheckboxModule,
    MatToolbarModule
  ],
  providers: [],
  entryComponents: [
    DialogRecComponent,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
